module.exports = __webpack_public_path__ + "static/media/orange-location-pin.b8e735e0.svg";